import { useMemo } from 'react'

import { Alert } from '@vtex/shoreline'
import { t } from 'i18next'

import RangeSlider from '~/components/RangeSlider'
import Tooltip from '~/components/Tooltip'
import { GOAL_AD_COST } from '~/modules/retailMedia/constants/objectiveBased'

import * as S from '../styles'

type HeaderProps = {
  goal: Goals
}

export const Header = ({ goal }: HeaderProps) => {
  const acosAlertMessage = useMemo(() => {
    const goalLabel = t(`rm:objectiveBased.strategy.${goal}`) as string
    return t(`rm:objectiveBased.acos.alert`, { goal: goalLabel })
  }, [goal])

  return (
    <S.Header>
      <S.RangeWrapper>
        <S.TooltipWrapper>
          <S.Title>{t('rm:objectiveBased.acos')}</S.Title>
          <Tooltip text={t('rm:objectiveBased.acos.tooltip')} />
        </S.TooltipWrapper>
        <RangeSlider
          isRangeValue
          min={goal ? (GOAL_AD_COST[goal]?.min ?? 0) : 0}
          max={goal ? (GOAL_AD_COST[goal]?.max ?? 0) : 0}
        />
      </S.RangeWrapper>

      <Alert variant="informational" style={{ maxWidth: '545px' }}>
        {acosAlertMessage}
      </Alert>
    </S.Header>
  )
}
